import { apiSlice } from "../api/apiSlice";

export const quizzesApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getQuizzes: builder.query({
			query: () => "/quizzes",
		}),
		addQuizz: builder.mutation({
			query: ({ data }) => ({
				url: "/quizzes",
				method: "POST",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const quizz = await queryFulfilled;
					if (quizz?.data?.id) {
						// update tasks cache pessimistically start
						dispatch(
							apiSlice.util.updateQueryData(
								"getQuizzes",
								undefined,
								(draft) => {
									// console.log(JSON.parse(JSON.stringify(draft)));
									draft.push(quizz.data)
								}
							)
						);
						// update tasks cache pessimistically end
					}
				} catch (err) { }
			},
		}),
		editQuizz: builder.mutation({
			query: ({ id, data }) => ({
				url: `/quizzes/${id}`,
				method: "PATCH",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				// optimistic cache update start
				const pathResult = dispatch(
					apiSlice.util.updateQueryData(
						"getQuizzes",
						undefined,
						(draft) => {
							const draftQuizz = draft.find((quizz) => quizz.id == arg.id);
							draftQuizz.question = arg.data.question;
							draftQuizz.video_id = arg.data.video_id;
							draftQuizz.video_title = arg.data.video_title;
							draftQuizz.options = arg.data.options;
						}
					)
				);
				// optimistic cache update end

				try {
					await queryFulfilled;
				} catch (err) {
					pathResult.undo();
				}
			},
		}),
		deleteQuizz: builder.mutation({
			query: ({ id }) => ({
				url: `/quizzes/${id}`,
				method: "DELETE",
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				// optimistic cache update start
				const result = dispatch(
					apiSlice.util.updateQueryData(
						"getQuizzes",
						undefined,
						(draft) => {
							return draft.filter((quizz) => quizz.id != arg.id);
						}
					)
				);
				// optimistic cache update end
				try {
					await queryFulfilled;
				} catch (err) {
					result.undo();
				}
			},
		}),
	}),
});

export const {
	useGetQuizzesQuery,
	useAddQuizzMutation,
	useEditQuizzMutation,
	useDeleteQuizzMutation
} = quizzesApi;


